/**
 * Path interno seguro al que se puede redirigir: absoluto (`/…`), no
 * protocol-relative (`//host`) y sin `\` — algunos navegadores normalizan los
 * backslashes a `/` antes de navegar, así que `/\evil.com` colaría como
 * protocol-relative si solo mirásemos `//`.
 *
 * Lo usa todo destino de vuelta que venga de fuera del componente (el
 * `?returnTo=` del wizard del RV, el `returnTo` que las tablas dejan en el
 * contexto de sesión de accidentes y comunicaciones). Vivía duplicado en
 * `EditRoute/action.ts` y en el resolutor de comunicaciones; al aparecer el
 * tercer y cuarto consumidor (2026-08-05) deja de tener sentido copiarlo.
 */
export function isInternalPath(path?: string | null): path is string {
  return (
    typeof path === 'string' &&
    path.startsWith('/') &&
    !path.startsWith('//') &&
    !path.includes('\\')
  );
}
